import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { StandardDrink } from '@barboxx/models';

interface Props {
    standardDrink: StandardDrink.DetailsResponse;
}

export const StandardDrinkDeleteCard = ({ standardDrink }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteStandardDrink = useMutation({
        mutationKey: ['deleteStandardDrink', standardDrink.id],
        mutationFn: () =>
            Api.StandardDrinks.StandardDrink.deleteStandardDrink(standardDrink),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this standard drink!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete standard drink',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteStandardDrink
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted standard drink!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting standard drink!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete StandardDrink" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this product?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
